// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.os-signup-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  z-index: 10100;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  animation: os-modal-fade-in 0.15s ease;
}

@keyframes os-modal-fade-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.os-signup-modal-panel {
  position: relative;
  background: #fff;
  border-radius: 16px;
  width: 100%;
  max-width: 560px;
  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.35);
  animation: os-modal-slide-up 0.18s ease;
  overflow: hidden;
}
[data-theme=dark] .os-signup-modal-panel {
  background: #1a1b1e;
  color: #f0f0f0;
}

.os-modal-laptop-hero {
  background: #111;
  padding: 20px 24px 0;
  overflow: hidden;
}
.os-modal-laptop-hero .orb-umbilical-wrapper {
  display: none;
}
.os-modal-laptop-hero .laptop-hero-container {
  max-width: 100%;
}

@keyframes os-modal-slide-up {
  from {
    transform: translateY(16px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}
.os-signup-modal-close {
  position: absolute;
  top: 14px;
  right: 14px;
  background: none;
  border: none;
  cursor: pointer;
  color: #999;
  padding: 6px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s ease;
  z-index: 1;
}
.os-signup-modal-close:hover {
  background: rgba(0, 0, 0, 0.06);
  color: #333;
}
[data-theme=dark] .os-signup-modal-close:hover {
  background: rgba(255, 255, 255, 0.08);
  color: #eee;
}

.os-signup-modal-body {
  padding: 36px 32px 28px;
}
.os-signup-modal-body .os-step-header {
  text-align: center;
  margin-bottom: 24px;
}
.os-signup-modal-body .os-step-header h2 {
  font-size: 22px;
  font-weight: 700;
  color: #1a1a1a;
  margin: 0 0 6px;
}
[data-theme=dark] .os-signup-modal-body .os-step-header h2 {
  color: #f0f0f0;
}
.os-signup-modal-body .os-step-header p {
  font-size: 14px;
  color: #666;
  margin: 0;
}
[data-theme=dark] .os-signup-modal-body .os-step-header p {
  color: #999;
}
.os-signup-modal-body .purchase-error {
  background: rgba(239, 68, 68, 0.1);
  color: #dc2626;
  padding: 10px 14px;
  border-radius: 8px;
  font-size: 13px;
  border: 1px solid rgba(239, 68, 68, 0.2);
  margin-bottom: 16px;
}
.os-signup-modal-body .purchase-summary {
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 12px;
  padding: 18px 20px;
}
[data-theme=dark] .os-signup-modal-body .purchase-summary {
  background: rgba(255, 255, 255, 0.04);
  border-color: rgba(255, 255, 255, 0.08);
}
.os-signup-modal-body .purchase-summary .summary-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 14px;
}
.os-signup-modal-body .purchase-summary .summary-header h3 {
  font-size: 15px;
  font-weight: 600;
  color: #1a1a1a;
  margin: 0;
}
[data-theme=dark] .os-signup-modal-body .purchase-summary .summary-header h3 {
  color: #e8e8e8;
}
.os-signup-modal-body .purchase-summary .summary-header .price {
  font-size: 22px;
  font-weight: 700;
  color: #1a1a1a;
}
[data-theme=dark] .os-signup-modal-body .purchase-summary .summary-header .price {
  color: #f0f0f0;
}
.os-signup-modal-body .purchase-summary .feature-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 7px;
}
.os-signup-modal-body .purchase-summary .feature-list li {
  font-size: 13px;
  color: #444;
  padding-left: 18px;
  position: relative;
}
.os-signup-modal-body .purchase-summary .feature-list li::before {
  content: "✓";
  position: absolute;
  left: 0;
  color: #10b981;
  font-weight: 700;
}
[data-theme=dark] .os-signup-modal-body .purchase-summary .feature-list li {
  color: #b0b0b0;
}
.os-signup-modal-body .stripe-checkout-section {
  margin-top: 24px;
}
.os-signup-modal-body .os-btn-primary {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 13px 20px;
  background: linear-gradient(180deg, var(--theme-gradient-secondary-start) 0%, var(--theme-gradient-secondary-end) 100%);
  color: var(--theme-gradient-secondary-text);
  border: none;
  border-radius: 10px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s ease;
  font-family: inherit;
  box-shadow: var(--theme-gradient-secondary-shadow);
}
.os-signup-modal-body .os-btn-primary:hover:not(:disabled) {
  background: linear-gradient(180deg, var(--theme-gradient-secondary-hover-start) 0%, var(--theme-gradient-secondary-hover-end) 100%);
  transform: translateY(-1px);
  box-shadow: var(--theme-gradient-secondary-shadow-hover);
}
.os-signup-modal-body .os-btn-primary:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.os-signup-modal-body .secure-note {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  font-size: 11px;
  color: #999;
  margin-top: 10px;
}
.os-signup-modal-body .already-purchased {
  margin-top: 16px;
  text-align: center;
}
.os-signup-modal-body .already-purchased p {
  font-size: 0.8em;
  opacity: 0.5;
  margin: 0;
}
.os-signup-modal-body .already-purchased-link {
  background: none;
  border: none;
  cursor: pointer;
  text-decoration: underline;
  font-size: inherit;
  opacity: 0.8;
  padding: 0;
  color: inherit;
}`, "",{"version":3,"sources":["webpack://./src/components/modals/OSSignupModal.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,eAAA;EACA,QAAA;EACA,8BAAA;EACA,0BAAA;EACA,kCAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,sCAAA;AAEF;;AACA;EACE;IAAO,UAAA;EAGP;EAFA;IAAO,UAAA;EAKP;AACF;AAHA;EACE,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,2CAAA;EACA,uCAAA;EACA,gBAAA;AAKF;AAHE;EACE,mBAAA;EACA,cAAA;AAKJ;;AADA;EACE,gBAAA;EACA,oBAAA;EACA,gBAAA;AAIF;AADE;EACE,aAAA;AAGJ;AAAE;EACE,eAAA;AAEJ;;AAEA;EACE;IAAO,2BAAA;IAA6B,UAAA;EAGpC;EAFA;IAAO,wBAAA;IAA6B,UAAA;EAMpC;AACF;AAJA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,0BAAA;EACA,UAAA;AAMF;AAJE;EACE,+BAAA;EACA,WAAA;AAMJ;AAJI;EACE,qCAAA;EACA,WAAA;AAMN;;AADA;EACE,uBAAA;AAIF;AAFE;EACE,kBAAA;EACA,mBAAA;AAIJ;AAFI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;AAIN;AAFM;EAAwB,cAAA;AAK9B;AAFI;EACE,eAAA;EACA,WAAA;EACA,SAAA;AAIN;AAFM;EAAwB,WAAA;AAK9B;AADE;EACE,kCAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,wCAAA;EACA,mBAAA;AAGJ;AAAE;EACE,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;AAEJ;AAAI;EACE,qCAAA;EACA,uCAAA;AAEN;AACI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AACN;AACM;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;AACR;AACQ;EAAwB,cAAA;AAEhC;AACM;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AACR;AACQ;EAAwB,cAAA;AAEhC;AAEI;EACE,gBAAA;EACA,UAAA;EACA,SAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AAAN;AAEM;EACE,eAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;AAAR;AAEQ;EACE,YAAA;EACA,kBAAA;EACA,OAAA;EACA,cAAA;EACA,gBAAA;AAAV;AAGQ;EAAwB,cAAA;AAAhC;AAKE;EACE,gBAAA;AAHJ;AAME;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,kBAAA;EACA,uHAAA;EACA,2CAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,0BAAA;EACA,oBAAA;EACA,kDAAA;AAJJ;AAMI;EACE,mIAAA;EACA,2BAAA;EACA,wDAAA;AAJN;AAOI;EACE,YAAA;EACA,mBAAA;AALN;AASE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;AAPJ;AAUE;EACE,gBAAA;EACA,kBAAA;AARJ;AAUI;EACE,gBAAA;EACA,YAAA;EACA,SAAA;AARN;AAYE;EACE,gBAAA;EACA,YAAA;EACA,eAAA;EACA,0BAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;EACA,cAAA;AAVJ","sourcesContent":[".os-signup-modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.6);\n  backdrop-filter: blur(4px);\n  -webkit-backdrop-filter: blur(4px);\n  z-index: 10100;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n  animation: os-modal-fade-in 0.15s ease;\n}\n\n@keyframes os-modal-fade-in {\n  from { opacity: 0; }\n  to   { opacity: 1; }\n}\n\n.os-signup-modal-panel {\n  position: relative;\n  background: #fff;\n  border-radius: 16px;\n  width: 100%;\n  max-width: 560px;\n  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.35);\n  animation: os-modal-slide-up 0.18s ease;\n  overflow: hidden;\n\n  [data-theme=\"dark\"] & {\n    background: #1a1b1e;\n    color: #f0f0f0;\n  }\n}\n\n.os-modal-laptop-hero {\n  background: #111;\n  padding: 20px 24px 0;\n  overflow: hidden;\n\n  // Suppress the orb — it's a full-viewport canvas not suited for modals\n  .orb-umbilical-wrapper {\n    display: none;\n  }\n\n  .laptop-hero-container {\n    max-width: 100%;\n  }\n}\n\n@keyframes os-modal-slide-up {\n  from { transform: translateY(16px); opacity: 0; }\n  to   { transform: translateY(0);    opacity: 1; }\n}\n\n.os-signup-modal-close {\n  position: absolute;\n  top: 14px;\n  right: 14px;\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: #999;\n  padding: 6px;\n  border-radius: 6px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.15s ease;\n  z-index: 1;\n\n  &:hover {\n    background: rgba(0, 0, 0, 0.06);\n    color: #333;\n\n    [data-theme=\"dark\"] & {\n      background: rgba(255, 255, 255, 0.08);\n      color: #eee;\n    }\n  }\n}\n\n.os-signup-modal-body {\n  padding: 36px 32px 28px;\n\n  .os-step-header {\n    text-align: center;\n    margin-bottom: 24px;\n\n    h2 {\n      font-size: 22px;\n      font-weight: 700;\n      color: #1a1a1a;\n      margin: 0 0 6px;\n\n      [data-theme=\"dark\"] & { color: #f0f0f0; }\n    }\n\n    p {\n      font-size: 14px;\n      color: #666;\n      margin: 0;\n\n      [data-theme=\"dark\"] & { color: #999; }\n    }\n  }\n\n  .purchase-error {\n    background: rgba(239, 68, 68, 0.1);\n    color: #dc2626;\n    padding: 10px 14px;\n    border-radius: 8px;\n    font-size: 13px;\n    border: 1px solid rgba(239, 68, 68, 0.2);\n    margin-bottom: 16px;\n  }\n\n  .purchase-summary {\n    background: #f8f9fa;\n    border: 1px solid #e9ecef;\n    border-radius: 12px;\n    padding: 18px 20px;\n\n    [data-theme=\"dark\"] & {\n      background: rgba(255, 255, 255, 0.04);\n      border-color: rgba(255, 255, 255, 0.08);\n    }\n\n    .summary-header {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      margin-bottom: 14px;\n\n      h3 {\n        font-size: 15px;\n        font-weight: 600;\n        color: #1a1a1a;\n        margin: 0;\n\n        [data-theme=\"dark\"] & { color: #e8e8e8; }\n      }\n\n      .price {\n        font-size: 22px;\n        font-weight: 700;\n        color: #1a1a1a;\n\n        [data-theme=\"dark\"] & { color: #f0f0f0; }\n      }\n    }\n\n    .feature-list {\n      list-style: none;\n      padding: 0;\n      margin: 0;\n      display: flex;\n      flex-direction: column;\n      gap: 7px;\n\n      li {\n        font-size: 13px;\n        color: #444;\n        padding-left: 18px;\n        position: relative;\n\n        &::before {\n          content: '✓';\n          position: absolute;\n          left: 0;\n          color: #10b981;\n          font-weight: 700;\n        }\n\n        [data-theme=\"dark\"] & { color: #b0b0b0; }\n      }\n    }\n  }\n\n  .stripe-checkout-section {\n    margin-top: 24px;\n  }\n\n  .os-btn-primary {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n    padding: 13px 20px;\n    background: linear-gradient(180deg, var(--theme-gradient-secondary-start) 0%, var(--theme-gradient-secondary-end) 100%);\n    color: var(--theme-gradient-secondary-text);\n    border: none;\n    border-radius: 10px;\n    font-size: 15px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.15s ease;\n    font-family: inherit;\n    box-shadow: var(--theme-gradient-secondary-shadow);\n\n    &:hover:not(:disabled) {\n      background: linear-gradient(180deg, var(--theme-gradient-secondary-hover-start) 0%, var(--theme-gradient-secondary-hover-end) 100%);\n      transform: translateY(-1px);\n      box-shadow: var(--theme-gradient-secondary-shadow-hover);\n    }\n\n    &:disabled {\n      opacity: 0.6;\n      cursor: not-allowed;\n    }\n  }\n\n  .secure-note {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 4px;\n    font-size: 11px;\n    color: #999;\n    margin-top: 10px;\n  }\n\n  .already-purchased {\n    margin-top: 16px;\n    text-align: center;\n\n    p {\n      font-size: 0.8em;\n      opacity: 0.5;\n      margin: 0;\n    }\n  }\n\n  .already-purchased-link {\n    background: none;\n    border: none;\n    cursor: pointer;\n    text-decoration: underline;\n    font-size: inherit;\n    opacity: 0.8;\n    padding: 0;\n    color: inherit;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
